window.customElements.define("fostr-mobilemenu", class FostrMobileMenu extends HTMLElement {

  constructor() {

    super();

    this.isVisible = false;
    this.transitionTime = 300;
    this.animationStyle = null;
    this.mobilemenuEl = null;
    this.bodyEl = null;
    this.pageWrapEl = null;
    this.themeStyle = null;
    this.isHiddenClass = 'mobilemenu--hidden';
    this.isVisibleClass = 'mobilemenu--isVisible';
    this.noScrollClass = 'overflow-hidden';
    this.isActiveClass = 'active';
    this.dropdownListTarget = '.mobilemenu__link[aria-expanded]';
    this.dropdownExpandedListTarget = '.mobilemenu__link[aria-expanded="true"]';
    this.tierActiveTarget = 'fostr-mobilemenu-tier.' + this.isActiveClass;
    this.linkTarget = '.mobilemenu__link';
    this.mobilemenuToggleTarget = '[data-mobilemenu="toggle"]';
    this.mobilemenuCloseTarget = 'fostr-mobilemenu-button-close,fostr-mobilemenu-curtain,.fostr-mobilemenu-button-close';
  }

  connectedCallback() {
    this.mobilemenuAddCurtain();
    this.mobilemenuEl = this.querySelector('fostr-mobilemenu aside');
    this.pageWrapEl = document.querySelector('.fostr-mobilemenu-page');
    this.bodyEl = document.querySelector('body')
    this.themeStyle = this.bodyEl.getAttribute('id')
    this.setMobilemenuAnimationStyle();
    this.setMobilemenu();

    let toggleButtons = document.querySelectorAll(this.mobilemenuToggleTarget);
    for (var i=0;i<toggleButtons.length;i++) {
      toggleButtons[i].addEventListener('click', this.toggleButtonEventClick.bind(this));
    }

    // Event Listeners
    this.addEventListener('click',this.mobilemenuCloseEventClick.bind(this));
    this.addEventListener('click',this.dropdownListEventClick.bind(this));
    this.addEventListener('click',this.backButtonEventClick.bind(this));
    this.addEventListener('click',this.tierLinkEventClick.bind(this));

    document.addEventListener("cart drawer:opened", this.mobilemenuHide.bind(this));
    document.addEventListener("drawer:opened", this.mobilemenuHide.bind(this));

    this.querySelectorAll('.shopify-currency-form select').forEach(function(element) {
      element.addEventListener('change', (event) => {
        event.target.form.submit();
      });
    });

  }

  disconnectedCallback() {

    // Remove classes
    this.pageWrapEl.classList.remove('active');
    this.pageWrapEl.classList.remove('mobilemenu--push-left');
    this.pageWrapEl.classList.remove('mobilemenu--push-right');
    this.pageWrapEl.classList.remove('mobilemenu--overlay-left');
    this.pageWrapEl.classList.remove('mobilemenu--overlay-right');
    this.pageWrapEl.classList.remove('mobilemenu--overlay-bottom');

    // Remove eventListeners
    let toggleButtons = document.querySelectorAll(this.mobilemenuToggleTarget);
    for (var i=0;i<toggleButtons.length;i++) {
      toggleButtons[i].removeEventListener('click', this.toggleButtonEventClick.bind(this));
    }

    this.removeEventListener('click',this.mobilemenuCloseEventClick.bind(this));
    this.removeEventListener('click',this.dropdownListEventClick.bind(this));
    this.removeEventListener('click',this.backButtonEventClick.bind(this));
    this.removeEventListener('click',this.tierLinkEventClick.bind(this));

    // Reset properties
    this.animationStyle = null;
  }

  setPositionFromTop() {
    let topPosition = 0;
    let header = document.querySelector('header');
    if (header) {
      topPosition += header.offsetHeight;

      // get position of sticky header from top of page
      topPosition += header.getBoundingClientRect().top;
    }

    // set curtain and aside position from top
    let curtain = document.querySelector('fostr-mobilemenu-curtain');
    if (curtain) {
      curtain.style.top = topPosition + 'px';
    }

    let aside = document.querySelector('fostr-mobilemenu aside');
    if (aside) {
      aside.style.top = topPosition + 'px';
    }
  }

  removeTopPositioning() {
    setTimeout(function() {
      // set curtain and aside position from top
      let curtain = document.querySelector('fostr-mobilemenu-curtain');
      if (curtain) {
        curtain.style.top = '0px';
      }

      let aside = document.querySelector('fostr-mobilemenu aside');
      if (aside) {
        aside.style.top = '0px';
      }
    }, this.transitionTime)
  }

  // Methods
  mobilemenuHide() {
    this.mobilemenuEl.setAttribute('aria-expanded', 'false');
    this.classList.remove(this.isVisibleClass);
    document.body.classList.remove(this.isVisibleClass);
    this.pageWrapEl.classList.remove(this.isActiveClass);
    this.bodyEl.classList.remove(this.noScrollClass);
    this.bodyEl.classList.remove(this.isVisibleClass);
    this.isVisible = false;
    this.setFirstTier();
    this.removeTopPositioning();
    document.dispatchEvent(new Event("mobilemenu:hidden"));
  }

  mobilemenuShow() {
    this.setPositionFromTop();
    this.mobilemenuEl.setAttribute('aria-expanded', 'true');
    this.classList.add(this.isVisibleClass);
    document.body.classList.add(this.isVisibleClass);
    this.pageWrapEl.classList.add(this.isActiveClass);
    this.bodyEl.classList.add(this.isVisibleClass);
    this.bodyEl.classList.add(this.noScrollClass);
    this.isVisible = true;
    document.dispatchEvent(new Event("mobilemenu:opened"));

    if (this.themeStyle === '#moon') {
      this.mobilemenuEl.style.top = 0
    } else {
      this.mobilemenuEl.style.top = `${(document.querySelector('#shopify-section-fostr-announcement-bar') || { clientHeight: 0 }).clientHeight + (document.querySelector('header.header') || { clientHeight: 0 }).clientHeight - window.pageYOffset}px`
    }
  }

  toggleButtonEventClick() {
    this.mobilemenuToggle();
    this.setFirstTier();
  }

  mobilemenuAddCurtain() {
    if (document.querySelector('fostr-mobilemenu-curtain')) return;
    this.innerHTML = '<fostr-mobilemenu-curtain></fostr-mobilemenu-curtain>' + this.innerHTML;
  }

  dropdownListEventClick(event) {
    if (!event.target.closest(this.dropdownListTarget)) return false;

    let dropdownListEl = event.target;

    if (dropdownListEl.getAttribute('aria-expanded') == 'false') {
      this.dropdownListCollapseAll(false)
      dropdownListEl.setAttribute('aria-expanded', 'true');
      const dropdownListContainerEl = dropdownListEl.nextElementSibling
      const dropdownListContentEl = dropdownListContainerEl.querySelector('.mobilemenu__link-list--inner')
      let offset = dropdownListContentEl.offsetHeight + 30;
      dropdownListContainerEl.style.maxHeight = `${offset}px`
      return true;
    }

    dropdownListEl.nextElementSibling.style.maxHeight = 0
    dropdownListEl.setAttribute('aria-expanded', 'false');

    return true;
  }

  dropdownListCollapseAll (transition = true) {
    // close all expanded dropdown lists
    let expandedDropdownListEls = this.mobilemenuEl.querySelectorAll(this.dropdownExpandedListTarget);
    const transitionTime = transition ? this.transitionTime : 0
    setTimeout(() => {
      for (var i = 0; i < expandedDropdownListEls.length; i++) {
        expandedDropdownListEls[i].setAttribute("aria-expanded", "false");
        expandedDropdownListEls[i].nextElementSibling.style.maxHeight = 0
      }
    }, transitionTime);
  }

  nextTier(tierEl) {
    if (!tierEl) return;

    tierEl.classList.add(this.isActiveClass);

    this.attachScrollingEventListener();
    this.setBackButton();
    this.dropdownListCollapseAll();
  }

  previousTier() {
    var activeTiers = this.mobilemenuEl.querySelectorAll(this.tierActiveTarget);
    var lastActiveTier = activeTiers[(activeTiers.length - 1)];

    lastActiveTier.classList.remove(this.isActiveClass);

    this.setBackButton();
    this.dropdownListCollapseAll();
  }

  setBackButton() {
    if (!this.mobilemenuEl) return;
    const tierHeader = this.mobilemenuEl.querySelector('fostr-mobilemenu-header')
    const backButton = this.mobilemenuEl.querySelector('fostr-mobilemenu-button-back');

    if (!backButton) return false;

    if (this.mobilemenuEl.querySelectorAll(this.tierActiveTarget).length == 1) {
      backButton.classList.add(this.isHiddenClass);
      if (tierHeader) tierHeader.classList.add(this.isHiddenClass)
    } else {
      backButton.classList.remove(this.isHiddenClass);
      if (tierHeader) tierHeader.classList.remove(this.isHiddenClass)
    }

    return true;
  }

  backButtonEventClick(event) {
    if (!event.target.closest('fostr-mobilemenu [data-mobilemenu="back"]')) return false;

    this.previousTier();

    return true;
  }

  unsetAllActiveTiers() {
    let activeTierEls = this.mobilemenuEl.querySelectorAll(this.tierActiveTarget);
    let self = this;
    setTimeout(() => {
      for (var i = 0; i < activeTierEls.length; i++) {
        let activeTierEl = activeTierEls[i];
        activeTierEl.classList.remove(self.isActiveClass);
      }
    }, this.transitionTime);
  }

  setFirstTier() {
    let tier1El = this.mobilemenuEl.querySelector('#tier-1-0-0');

    if (!tier1El) return;

    if (tier1El.classList.contains(this.isActiveClass)) {
      this.unsetAllActiveTiers();
      this.dropdownListCollapseAll();
    }
    else {
      tier1El.classList.add(this.isActiveClass);
      this.attachScrollingEventListener();
    }

    this.setBackButton();
  }

  mobilemenuToggle() {
    if (!this.mobilemenuEl) return;

    if (!this.isVisible) {
      this.mobilemenuShow();
    }
    else {
      this.mobilemenuHide();
    }
  }

  setMobilemenuAnimationStyle() {
    if (!this.mobilemenuEl) return false;

    this.animationStyle = (this.mobilemenuEl.classList.contains('mobilemenu--push-left')) ? 'push-left' : this.animationStyle;
    this.animationStyle = (this.mobilemenuEl.classList.contains('mobilemenu--push-right')) ? 'push-right' : this.animationStyle;
    this.animationStyle = (this.mobilemenuEl.classList.contains('mobilemenu--overlay-left')) ? 'overlay-left' : this.animationStyle;
    this.animationStyle = (this.mobilemenuEl.classList.contains('mobilemenu--overlay-right')) ? 'overlay-right' : this.animationStyle;
    this.animationStyle = (this.mobilemenuEl.classList.contains('mobilemenu--overlay-bottom')) ? 'overlay-bottom' : this.animationStyle;
  }

  isAnimationStylePush() {
    return (this.animationStyle === 'push-left' || this.animationStyle === 'push-right');
  }

  setMobilemenu() {
    if (!this.mobilemenuEl) return false;

    if (!this.pageWrapEl) {
      console.log('Fostr MobileMenu: Please add the page wrap.');
      return;
    }

    this.pageWrapEl.classList.add('mobilemenu--' + this.animationStyle);
    this.classList.add('mobilemenu--' + this.animationStyle);

    return true;
  }

  // Event handlers
  tierLinkEventClick(event) {
    if (!event.target.closest(this.linkTarget)) return false;

    if (event.target.tagName === 'A') return;

    let linkEl = event.target;
    if (linkEl.nextElementSibling) return true;

    let nextTierEl = this.mobilemenuEl.querySelector('#' + linkEl.id.replace('-link', ''));
    if (!nextTierEl) return true;

    this.nextTier(nextTierEl);

    return true;
  }

  mobilemenuCloseEventClick(event) {
    if (!event.target.closest(this.mobilemenuCloseTarget)) return false;

    this.mobilemenuHide();
  }

  attachScrollingEventListener() {
    if (!this.mobilemenuEl) return;

    let lastActiveTierEl = this.mobilemenuEl.querySelectorAll('.' + this.isActiveClass + ':not(.mobilemenu--watchingScroll)')[this.mobilemenuEl.querySelectorAll('.' + this.isActiveClass + ':not(.mobilemenu--watchingScroll)').length - 1];
    if (!lastActiveTierEl) return;

    let lastActiveTierBodyEl = lastActiveTierEl.querySelector('fostr-mobilemenu-tier-body');
    if (!lastActiveTierBodyEl) return;

    lastActiveTierBodyEl.addEventListener('scroll',() => {
      if (!lastActiveTierBodyEl) return;

      if (lastActiveTierBodyEl.scrollTop > 0) {
        lastActiveTierEl.classList.add('mobilemenu--scrolling');
      }
      else {
        lastActiveTierEl.classList.remove('mobilemenu--scrolling');
      }
    }, {
      passive: true
    });

    lastActiveTierEl.classList.add('mobilemenu--watchingScroll');
  }
})
